<div class="ag-theme-alpine" style="width: 100%; height: 100%;">
    <ag-grid-angular class="ag-theme-alpine compact-centered" style="width: 100%; height: 100%;"
        [rowData]="rows"
        [columnDefs]="columns"
        [defaultColDef]="defaultColDef"
        [components]="components"
        [gridOptions]="gridOptions"
        [tooltipShowDelay]="300"
        [context]="{ componentParent: this }"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        (gridSizeChanged)="onGridSizeChanged($event)"
        (cellClicked)="onCellClicked($event)"
        [enableRangeSelection]="false"
        [suppressRowClickSelection]="true"
        [suppressDragLeaveHidesColumns]="true"
        [suppressMovableColumns]="true">
    </ag-grid-angular>
</div>
